
<div class="grid-x title">
  <div class="cell large-12 bold">
    {{position}} - {{casingType}}
    @if (enableEditing) {
      @if (!activeEditing) {
        <button (click)="setActive()">
          <svg-icon icon="icon-pencil" class="tiny dark-gray"></svg-icon>
        </button>
      }
      @if (segmentIndex !== 0) {
        <button (click)="deleteSegment()">
          <svg-icon icon="icon-trash" class="tiny dark-gray"></svg-icon>
        </button>
      }
    }
    @if (!enableEditing && !activeEditing) {
      <button (click)="setActive()">
        <svg-icon icon="icon-view" class="tiny dark-gray"></svg-icon>
      </button>
    }
  </div>
</div>
@if (activeEditing) {
  <div class="padding-all border">
    @if (substep === steps.Casing) {
      @if (showEditWarning) {
        <div class="grid-x edit-warning padding-left padding-right margin-bottom">
          <div class="cell large-1">
            <svg-icon icon="icon-alert" class="small"></svg-icon>
          </div>
          <div class="cell large-11">
            Changing the casing type will delete any subsequent strings.
          </div>
        </div>
      }
      <div class="grid-x" [formGroup]="formGroup">
        <div class="cell large-12">
          <label class="bold" for="casingSelector">
            Select @if (segmentIndex !== 0) {
            <span>Next</span>
            } String
          </label>
        </div>
        <div class="cell large-12">
          @if (availableCasings$) {
            <select id="casingSelector" formControlName="selectedCasing" (change)="validateForm()">
              @for (c of availableCasings$ | async; track c) {
                <option [ngValue]="c.code">{{c.definition}}</option>
              }
            </select>
          }
          @if (!availableCasings$) {
            Loading available casings...
          }
        </div>
      </div>
      @if (casingType !== '') {
        <div class="grid-x">
          <div class="cell large-12 text-align-right">
            @if (showCasingDefinition) {
              Hide Casing Definition
            }
            @if (!showCasingDefinition) {
              Show Casing Definition
            }
            <button (click)="toggleContent('casingDefinition')">
              @if (showCasingDefinition) {
                <svg-icon icon="icon-minus" class="small medium-gray"></svg-icon>
              }
              @if (!showCasingDefinition) {
                <svg-icon icon="icon-plus" class="small medium-gray"></svg-icon>
              }
            </button>
          </div>
          @if (showCasingDefinition) {
            <div class="cell large-12">
              <casing-data-pages [casingType]="wellSegment.casingType.definition"></casing-data-pages>
            </div>
          }
        </div>
      }
    }
    @if (substep === steps.Conditions) {
      <div class="grid-x" [formGroup]="formGroup">
        <div class="cell large-12">
          <label class="bold" for="conditionSelector">
            What is the condition of your pipe?
          </label>
        </div>
        <div class="cell large-12 margin-bottom">
          <select id="conditionSelector" formControlName="selectedCondition" (change)="validateForm()">
            @for (c of availableConditions$ | async; track c) {
              <option [ngValue]="c.id">{{c.name}}</option>
            }
          </select>
        </div>
        @if (editingWellSegment.casingCondition?.name?.toLowerCase() === 'reconditioned') {
          <div class="cell large-12 margin-bottom">
            <div class="checkbox">
              <input class="show-for-sr" type="checkbox" id="reconditionAccept" formControlName="reconditionAccept" (change)="validateForm()">
              <label for="reconditionAccept">
                <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
                <span class="control-label-text">  I have read, understand, and accept the rules regarding the use of reconditioned casing.</span>
              </label>
            </div>
          </div>
          <div class="cell large-11">
            In light of the following standards, are you certain that you want to use reconditioned casing?
          </div>
          <div class="cell large-1">
            <select formControlName="reconditionAcknowledge" (change)="validateForm()">
              <option selected value="">---</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
          <div class="cell large-12 text-align-right">
            @if (!showReconditionedInfo) {
              Show Reconditioned Information
            }
            @if (showReconditionedInfo) {
              Hide Reconditioned Information
            }
            <button (click)="toggleContent('reconditionedInfo')">
              @if (showReconditionedInfo) {
                <svg-icon icon="icon-minus" class="small medium-gray"></svg-icon>
              }
              @if (!showReconditionedInfo) {
                <svg-icon icon="icon-plus" class="small medium-gray"></svg-icon>
              }
            </button>
          </div>
          @if (showReconditionedInfo) {
            <div class="cell large-12">
              <ul>
                <li>
                  Reconditioned casing that is permanently set in a well shall be hydrostatically pressure tested with an applied pressure at least 1.2 times the
                  maximum internal pressure to which the casing may be subjected, based upon known or anticipated subsurface pressure, or pressure that may be applied
                  during simulation, whichever is greater, and assuming no external pressure. The casing shall be marked to verify the test status. The owner shall
                  provide a copy of the test results to the inspector before the casing is installed in the well.
                </li>
                <li>
                  Where subsurface reservoir pressure is unknown and cannot be reasonably anticipated, the owner shall assume a pressure gradient of 0.45 pounds
                  per square inch per foot in a fully evacuated hole, under shut-in conditions.
                </li>
                <li>All hydrostatic pressure tests shall be conducted pursuant to API "5 CT Specification for Casing and Tubing" or other method(s) approved by the chief.</li>
                <li>
                  Reconditioned casing shall not be set in a well unless it has passed an approved hydrostatic pressure and drift test or has otherwise been approved
                  by the inspector.
                </li>
              </ul>
            </div>
          }
        }
      </div>
    }
    @if (substep === steps.Tools) {
      @if (showEditWarning) {
        <div class="grid-x edit-warning padding-left padding-right margin-bottom">
          <div class="cell large-1">
            <svg-icon icon="icon-alert" class="small"></svg-icon>
          </div>
          <div class="cell large-11">
            Changing the drill tool to or from Concentric will cause all size and depth data from this string to be deleted, and all subsequent strings to be deleted.
          </div>
        </div>
      }
      <div class="grid-x" [formGroup]="formGroup">
        <div class="cell large-12">
          <label class="bold" for="toolSelector">What type of drilling equipment will be used to drill this section?</label>
        </div>
        <div class="cell large-12">
          @if (availableTools$) {
            <select id="toolSelector" formControlName="selectedTool" (change)="validateForm()">
              @for (t of availableTools$ | async; track t) {
                <option [ngValue]="t.code">{{t.definition}}</option>
              }
            </select>
          }
        </div>
      </div>
    }
    @if (substep === steps.Points) {
      @if (packerRequired && wellSegment.casingType.Definition === casingTypes.Tubing) {
        <p>For all UIC Applications (new wells and conversions), injection is required to be through tubing with a packer set no more than one hundred feet (100') above the designated injection zone.  The casing in which the tubing and packer are set must be encased with at least three hundred feet (300') of cement above the top of the injection zone.  Submission of a cement bond log will be required to assure that these conditions are met.</p>
        <p><a class="rules-link" target="_blank" href="/law-library/0nhh0w0np1qw2mMR">ORC 1501:9-3-05 (A)(3)</a><br />
        <a class="rules-link" href="">ORC 1501:9-3-05 (B)(4)</a><br />
        <a class="rules-link" href="">ORC 1501:9-5-09 (A)(3)</a><br />
        <a class="rules-link" href="">ORC 1501:9-5-09 (B)(4)</a></p>
      }
      <casing-size-and-depth [casingPlan]="currentCasingPlan" [wellDirection]="wellDirection" [wellSegment]="wellSegment" [previousSegment]="previousSegment" [rulesService]="rulesService" [saveInProgress]="saveInProgress" [segmentIndex]="segmentIndex" (formReady)="onFormReady($event)" (dataChanged)="dataChanged($event)"></casing-size-and-depth>
    }
    @if (substep === steps.Angles) {
      <div class="grid=x">
        <div class="cell large-12">
          <label class="bold" for="anglesCheck">
            Are you going to build any angle on this string?
          </label>
        </div>
        <div class="cell large-12">
          <select [(ngModel)]="wellSegment.hasAngles">
            <option [ngValue]="true">Yes</option>
            <option [ngValue]="false">No</option>
          </select>
        </div>
      </div>
    }
    @if (substep === steps.AngleBuilder) {
      <h3>Add GIS Info</h3>
      @if (requireAngles) {
        <div class="grid-x">
          <div class="cell large-12 edit-warning padding-left padding-right margin-bottom">
            Due to a previous string containing angles, the 'End' point of this string must be manually entered.  If this string requires any angles, enter them here.  If this string does not require any angles, you must still define the 'End' point of the string.
          </div>
        </div>
      }
      @if (!hasStartAndEnd) {
        <div class="grid-x">
          <div class="cell large-12">
            <label class="required red small-font-size">
              Each string must contain at least a Start and an End Point
            </label>
          </div>
        </div>
      }
      <div class="grid-x grid-margin-x align-bottom">
        <div class="cell medium-12">
          <label for="pointType" class="small-font-size">Point Type</label>
          <select id="pointType" [(ngModel)]="newGisObject.point">
            @for (option of pointOptionList; track option) {
              <option [value]="option.id" [disabled]="startEndDisabled(option.text)">{{option.text}}</option>
            }
          </select>
        </div>
      </div>
      <div class="grid-x grid-margin-x align-bottom">
        <div class="cell medium-4">
          <label for="measuredDepth" class="small-font-size">Measured Depth (ft)</label>
          <input id="measuredDepth" [(ngModel)]="newGisObject.md" type="number" />
        </div>
        <div class="cell medium-4">
          <label for="inclination" class="small-font-size">Inclination (&#176;)</label>
          <input id="inclination" [(ngModel)]="newGisObject.inclination" type="number" />
        </div>
        <div class="cell medium-4">
          <label for="azimuth" class="small-font-size">Azimuth (&#176;)</label>
          <input id="azimuth" [(ngModel)]="newGisObject.azimuth" type="number" />
        </div>
      </div>
      <div class="grid-x grid-margin-x align-bottom">
        <div class="cell medium-3">
          <label for="tvd" class="small-font-size red">True Vertical Depth (ft)*</label>
          <input [(ngModel)]="newGisObject.tvd" type="number" id="tvd" />
        </div>
        <div class="cell medium-3">
          <label for="vertSect" class="small-font-size">Vert Sect (ft)</label>
          <input [(ngModel)]="newGisObject.vertSect" type="number" id="vertSect" />
        </div>
        <div class="cell medium-3">
          <label for="latitude" class="small-font-size red">Latitude*</label>
          <input [(ngModel)]="newGisObject.latitude" type="number" id="latitude" />
        </div>
        <div class="cell medium-3">
          <label for="longitude" class="small-font-size red">Longitude*</label>
          <input [(ngModel)]="newGisObject.longitude" type="number" id="longitude" />
        </div>
      </div>
      <div class="grid-x grid-margin-x align-bottom">
        <div class="cell medium-3">
          <label for="north" class="small-font-size">North (ft)</label>
          <input [(ngModel)]="newGisObject.north" type="number" id="north" />
        </div>
        <div class="cell medium-3">
          <label for="east" class="small-font-size">East (ft)</label>
          <input [(ngModel)]="newGisObject.east" type="number" id="east" />
        </div>
        <div class="cell medium-3">
          <label for="gridEast" class="small-font-size">Grid East (US ft)</label>
          <input [(ngModel)]="newGisObject.gridEast" type="number" id="gridEast" />
        </div>
        <div class="cell medium-3">
          <label for="gridNorth" class="small-font-size">Grid North (US ft)</label>
          <input [(ngModel)]="newGisObject.gridNorth" type="number" id="gridNorth" />
        </div>
      </div>
      <div class="grid-x grid-margin-x align-bottom">
        <div class="cell medium-3">
          <label for="closureDistance" class="small-font-size">Closue Distance (ft)</label>
          <input [(ngModel)]="newGisObject.closureDistance" type="number" id="closureDistance" />
        </div>
        <div class="cell medium-3">
          <label for="dls" class="small-font-size">Dog Leg Severity (&#176;/100 ft)</label>
          <input [(ngModel)]="newGisObject.dls" type="number" id="dls" />
        </div>
        <div class="cell medium-3">
          <label for="buildRate" class="small-font-size">Build Rate (&#176;/100 ft)</label>
          <input [(ngModel)]="newGisObject.buildRate" type="number" id="buildRate" />
        </div>
        <div class="cell medium-3">
          <label for="turnRate" class="small-font-size">Turn Rate(&#176;/100 ft)</label>
          <input [(ngModel)]="newGisObject.turnRate" type="number" id="turnRate" />
        </div>
      </div>
      <div class="grid-x grid-margin-x">
        <div class="cell medium-12 text-align-right">
          <button class="button margin-top" [disabled]="gisObjectInvalid" (click)="addGisDataToWellSegment()">Add Point</button>
        </div>
      </div>
      @if (wellSegment.gisObjects.length) {
        <ag-grid-angular class="major-margin-top gis-ag-grid "
          [rowData]="wellSegment.gisObjects"
          [columnDefs]="gisColumnDefs"
          (gridReady)="gisOnGridReady($event)"
        [gridOptions]="gisGridOptions" aria-label="Well Segment Wizard"></ag-grid-angular>
      }
    }
    @if (substep === steps.ReviewWellSegment) {
      <h3>Review</h3>
      <div class="grid-x">
        <div class="cell large-12 casing-title-bar">
          <p>String Details</p>
        </div>
      </div>
      @if (wellSegment) {
        <ag-grid-angular class="data-grid gis-ag-grid "
          [rowData]="segmentData"
          [columnDefs]="segmentColumnDefs"
          (gridReady)="segmentGridOnReady($event)"
          style="height: auto !important"
          [gridOptions]="segmentGridOptions" aria-label="Well Segment Wizard">
        </ag-grid-angular>
      }
      <div class="grid-x">
        <div class="cell large-12 casing-title-bar">
          <p>GIS Information</p>
        </div>
      </div>
      @if (wellSegment.gisObjects.length) {
        <ag-grid-angular class="data-grid major-margin-top gis-ag-grid "
          [rowData]="wellSegment.gisObjects"
          [columnDefs]="gisColumnDefsNoEdit"
          (gridReady)="gisOnGridReady($event)"
          style="height: auto !important"
        [gridOptions]="gisGridOptions" aria-label="Well Segment Wizard"></ag-grid-angular>
      }
      <tabs class="tab-content major-margin-top display-block">
        <tab title="Schematic View">
          @if (whatDetail() === 'Vertical') {
            <casing-plan-2d-detail-vertical [applicationData]="applicationData" [segment]="wellSegment" [length]="1" [segmentIndex]="segmentIndex"></casing-plan-2d-detail-vertical>
          }
          @if (whatDetail() == 'Horizontal') {
            <casing-plan-2d-detail-horizontal [applicationData]="applicationData" [segment]="wellSegment" [length]="1" [segmentIndex]="segmentIndex"></casing-plan-2d-detail-horizontal>
          }
          @if (whatDetail() === 'Directional') {
            <casing-plan-2d-detail-directional [applicationData]="applicationData" [segment]="wellSegment" [length]="1" [segmentIndex]="segmentIndex"></casing-plan-2d-detail-directional>
          }
        </tab>
        <tab title="3d View">
          <odnr-map [mode]="1" [casingPlan]="currentCasingPlan" [longitude]="currentCasingPlan.surfaceLongitude" [latitude]="currentCasingPlan.surfaceLatitude" [zoom]="18"></odnr-map>
        </tab>
      </tabs>
      <div class="grid-x">
        <div class="cell large-4">
          <h4>String Requirements:</h4>
        </div>
        <div class="cell large-5 align-left">
          {{wellSegment.casingType.definition}}
        </div>
        <div class="cell large-3 text-align-right">
          @if (showSegmentRules) {
            Hide Casing Type Rules
          }
          @if (!showSegmentRules) {
            Show Casing Type Rules
          }
          <button (click)="toggleContent('segmentRules')">
            @if (showSegmentRules) {
              <svg-icon icon="icon-minus" class="small medium-gray"></svg-icon>
            }
            @if (!showSegmentRules) {
              <svg-icon icon="icon-plus" class="small medium-gray"></svg-icon>
            }
          </button>
        </div>
      </div>
      @if (showSegmentRules) {
        <div class="cell large-12">
          @switch (true) {
            @case (wellSegment.casingType.definition === casingTypes.DrivePipe) {
              <a class="rules-link" href="/law-library/CJ7rrDDlMa1FZu" target="_blank">Drilling Fluids OAC 1501:9-1-08 (C)(1)</a><br />
              <a class="rules-link" href="/law-library/10PjqP16msCtYlq" target="_blank">Casing Standards OAC 1501:9-1-08 (D)(1)(2)</a><br />
              <a class="rules-link" href="/law-library/10Pjsl16uCWz0Vz8" target="_blank">Notification OAC 1501:9-1-08 (L)</a><br />
              @if (segmentLength > 200) {
                <a class="rules-link" href="/law-library/CJ83GDKYAF1kzf" target="_blank">Casing Pressure Tests OAC 1501:9-1-08 (D)(3)</a><br />
              }
              @if (segmentIndex === 0) {
                <a class="rules-link" href="/law-library/10PjAf16x7xV1MG8" target="_blank">Surface Water Infiltration OAC 1501:9-1-08 (F)</a><br />
              }
            }
            @case (wellSegment.casingType.definition === casingTypes.Surface) {
              <a class="rules-link" href="/law-library/CJ7rrDDlMa1FZu" target="_blank">Drilling Fluids OAC 1501:9-1-08 (C)(1)</a><br />
              <a class="rules-link" href="/law-library/10PjqP16msCtYlq" target="_blank">Casing Standards OAC 1501:9-1-08 (D)(1)(2)</a><br />
              <a class="rules-link" href="/law-library/10Pjvr16vv8t059" target="_blank">Cement Standards OAC 1501:9-1-08 (J)(1)(2)(4)(6)(8)</a><br />
              <a class="rules-link" href="/law-library/10PjtU16v5gi0JOw" target="_blank">Wellbore Conditioning OAC 1501:9-1-08 (I)(1)(3)</a><br />
              <a class="rules-link" href="/law-library/10Pjvr16vv8t059" target="_blank">Cement Standards OAC 1501:9-1-08 (J)(1)(2)(4)(6)(8)(a)(i)</a><br />
              <a class="rules-link" href="/law-library/10PjyA16wwCo0uJr" target="_blank">Centralizers OAC 1501:9-1-08 (K)</a><br />
              <a class="rules-link" href="/law-library/10Pjyz16wt2M1hCQ" target="_blank">Groundwater Protection OAC 1501:9-1-08 (M)(2)(c)</a><br />
              <a class="rules-link" href="/law-library/10Pjx~16way~2ilX" target="_blank">Cement Operations OAC 1501:9-1-08 (M)(4)(b)(c)</a><br />
              <a class="rules-link" href="/law-library/10PjAd16x01R2uMM" target="_blank">Annular Pressure Monitoring OAC 1501:9-1-08 (N)(2)(3)</a><br />
              <a class="rules-link" href="/law-library/10PjAb16wUb81qhp" target="_blank">Annular Pressure Monitoring OAC 1501:9-1-08 (N)(5)</a><br />
              <a class="rules-link" href="/law-library/10Pjsl16uCWz0Vz8" target="_blank">Notification OAC 1501:9-1-08 (L)</a><br />
              @if (hasConductorString && glacialDrift > 100) {
                <a class="rules-link" href="/law-library/10PjyD16wHVDnD~" target="_blank">Guide Shoe OAC 1501:9-1-08 (M)(4)(e)</a><br />
              }
              @if (segmentLength > 200) {
                <a class="rules-link" href="/law-library/CJ83GDKYAF1kzf" target="_blank">Casing Pressure Tests OAC 1501:9-1-08 (D)(3)</a><br />
              }
              @if (segmentIndex === 0) {
                <a class="rules-link" href="/law-library/10PjAf16x7xV1MG8" target="_blank">Surface Water Infiltration OAC 1501:9-1-08 (F)</a><br />
              }
            }
            @case (wellSegment.casingType.definition === casingTypes.MineString) {
              <a class="rules-link" href="/law-library/CJ7rrDDlMa1FZu" target="_blank">Drilling Fluids OAC 1501:9-1-08 (C)(1)</a><br />
              <a class="rules-link" href="/law-library/10PjqP16msCtYlq" target="_blank">Casing Standards OAC 1501:9-1-08 (D)(1)(2)</a><br />
              <a class="rules-link" href="/law-library/10PjAe16x3loyc6" target="_blank">Casing through any underground mine OAC 1501:9-1-08 (M)(2)(b)</a><br />
              <a class="rules-link" href="/law-library/10Pjyz16wt2M1hCQ" target="_blank">Groundwater Protection OAC 1501:9-1-08 (M)(2)(c)</a><br />
              <a class="rules-link" href="/law-library/10PjtU16v5gi0JOw" target="_blank">Wellbore Conditioning OAC 1501:9-1-08 (I)(1)(3)</a><br />
              <a class="rules-link" href="/law-library/10Pjvr16vv8t059" target="_blank">Cement Standards OAC 1501:9-1-08 (J)(1)(2)(4)(6)(8)(a)(i)</a><br />
              <a class="rules-link" href="/law-library/10PjyA16wwCo0uJr" target="_blank">Centralizers OAC 1501:9-1-08 (K)</a><br />
              <a class="rules-link" href="/law-library/10PjyB16wAWi2FRw" target="_blank">Cement Basket 1501:9-1-08 (M)(2)(e)(i)(iii)</a><br />
              <a class="rules-link" href="/law-library/10PjyC16wEvj0BPq" target="_blank">Guide Shoe OAC 1501:9-1-08 (M)(2)(d)</a><br />
              <a class="rules-link" href="/law-library/10PjyE16wLPy1qR7" target="_blank">Cement Operations OAC 1501:9-1-08 (M)(2)(e)</a><br />
              <a class="rules-link" href="/law-library/10PjAb16wUb81qhp" target="_blank">Annular Pressure Monitoring OAC 1501:9-1-08 (N)(5)</a><br />
              <a class="rules-link" href="/law-library/10Pjsl16uCWz0Vz8" target="_blank">Notification OAC 1501:9-1-08 (L)</a><br />
              @if (inActiveMineArea) {
                <a class="rules-link" href="/law-library/10Pjyy16woZb03aj" target="_blank">Casing through an active underground mine OAC 1501:9-1-08 (M)(2)(a)</a><br />
              }
              @if (segmentLength > 200) {
                <a class="rules-link" href="/law-library/CJ83GDKYAF1kzf" target="_blank">Casing Pressure Tests OAC 1501:9-1-08 (D)(3)</a><br />
              }
              @if (segmentIndex === 0) {
                <a class="rules-link" href="/law-library/10PjAf16x7xV1MG8" target="_blank">Surface Water Infiltration OAC 1501:9-1-08 (F)</a><br />
              }
            }
            @case (wellSegment.casingType.definition === casingTypes.Intermediate1 || wellSegment.casingType.Definition === casingTypes.Intermediate2 || wellSegment.casingType.Definition === casingTypes.Intermediate1Entry || wellSegment.casingType.Definition === casingTypes.Intermediate2Entry) {
              <a class="rules-link" href="/law-library/10Pjpi16lPFS1SJk" target="_blank">Drilling Fluids OAC 1501:9-1-08 (C)(3)</a><br />
              <a class="rules-link" href="/law-library/10PjqP16msCtYlq" target="_blank">Casing Standards OAC 1501:9-1-08 (D)(1)(2)</a><br />
              <a class="rules-link" href="/law-library/CJ83GDKYAF1kzf" target="_blank">Casing Pressure Tests OAC 1501:9-1-08 (D)(3)</a><br />
              @if (casingShoeDepth) {
                <a class="rules-link" href="/law-library/10PjAg16xarS0oRM" target="_blank">Casing Shoe Test OAC 1501:9-1-08 (E)</a><br />
              }
              <a class="rules-link" href="/law-library/10PjtS16uLW2qXV" target="_blank">Wellbore Conditioning OAC 1501:9-1-08 (I)</a><br />
              <a class="rules-link" href="/law-library/10Pjvs16vHtQmvX" target="_blank">Cement Standards OAC 1501:9-1-08 (J)(1)(3)(4)(6)(8)(a)(ii)</a><br />
              <a class="rules-link" href="/law-library/10PjyA16wwCo0uJr" target="_blank">Centralizers OAC 1501:9-1-08 (K)</a><br />
              <a class="rules-link" href="/law-library/10Pjyz16wt2M1hCQ" target="_blank">Groundwater Protection OAC 1501:9-1-08 (M)(2)(c)</a><br />
              <a class="rules-link" href="/law-library/10Pjx016wg~r1~sU" target="_blank">Cement Operations OAC 1501:9-1-08 (M)(6)(b)(c)(d)</a><br />
              <a class="rules-link" href="/law-library/10PjAh16xfuC19I~" target="_blank">Flow Zone Isolation OAC 1501:9-1-08 (M)(6)(d)(e)</a><br />
              <a class="rules-link" href="/law-library/10PjAc16wXQzWVE" target="_blank">Annular Pressure OAC 1501:9-1-08 (M)(6)(d)</a><br />
              <a class="rules-link" href="/law-library/10PjAd16x01R2uMM" target="_blank">Annular Pressure OAC 1501:9-1-08 (N)(3)</a><br />
              <a class="rules-link" href="/law-library/10Pjsl16uCWz0Vz8" target="_blank">Notification OAC 1501:9-1-08 (L)</a><br />
            }
            @case (wellSegment.casingType.definition === casingTypes.Production) {
              <a class="rules-link" href="/law-library/10Pjpi16lPFS1SJk" target="_blank">Drilling Fluids OAC 1501:9-1-08 (C)(3)</a><br />
              <a class="rules-link" href="/law-library/10PjqP16msCtYlq" target="_blank">Casing Standards OAC 1501:9-1-08 (D)(1)(2)</a><br />
              <a class="rules-link" href="/law-library/CJ83GDKYAF1kzf" target="_blank">Casing Pressure Tests OAC 1501:9-1-08 (D)(3)</a><br />
              @if (casingShoeDepth) {
                <a class="rules-link" href="/law-library/10PjAg16xarS0oRM" target="_blank">Casing Shoe Test OAC 1501:9-1-08 (E)</a><br />
              }
              <a class="rules-link" href="/law-library/10PjtS16uLW2qXV" target="_blank">Wellbore Conditioning OAC 1501:9-1-08 (I)</a><br />
              <a class="rules-link" href="/law-library/10Pjvs16vHtQmvX" target="_blank">Cement Standards OAC 1501:9-1-08 (J)(1)(3)(4)(6)(8)(a)(ii)</a><br />
              <a class="rules-link" href="/law-library/10PjyA16wwCo0uJr" target="_blank">Centralizers OAC 1501:9-1-08 (K)</a><br />
              <a class="rules-link" href="/law-library/10Pjx116wk4FcI0" target="_blank">Cement Operations OAC 1501:9-1-08 (M)(7)(a)</a><br />
              <a class="rules-link" href="/law-library/10PjAi16xjtE2Umi" target="_blank">Flow Zone Isolation OAC 1501:9-1-08 (M)(7)(a)(i)</a><br />
              <a class="rules-link" href="/law-library/10PjAb16wUb81qhp" target="_blank">Annular Pressure Monitoring OAC 1501:9-1-08 (N)(5)</a><br />
              <a class="rules-link" href="/law-library/10Pjsl16uCWz0Vz8" target="_blank">Notification OAC 1501:9-1-08 (L)</a><br />
            }
            @case (wellSegment.casingType.definition === casingTypes.Conductor) {
              <a class="rules-link" href="/law-library/CJ7rrDDlMa1FZu" target="_blank">Drilling Fluids OAC 1501:9-1-08 (C)(1)</a><br />
              <a class="rules-link" href="/law-library/10PjqP16msCtYlq" target="_blank">Casing Standards OAC 1501:9-1-08 (D)(1)(2)</a><br />
              <a class="rules-link" href="/law-library/10PjtS16uLW2qXV" target="_blank">Wellbore Conditioning OAC 1501:9-1-08 (I)(1)</a><br />
              <a class="rules-link" href="/law-library/10Pjvr16vv8t059" target="_blank">Cement Standards OAC 1501:9-1-08 (J)(1)(2)(4)(6)(8)(a)(i)</a><br />
              <a class="rules-link" href="/law-library/10Pjvt16vNF20CEe" target="_blank">Cement Operations OAC 1501:9-1-08 (M)(3)</a><br />
              <a class="rules-link" href="/law-library/10Pjsl16uCWz0Vz8" target="_blank">Notification OAC 1501:9-1-08 (L)</a><br />
              @if (segmentLength > 200) {
                <a class="rules-link" href="/law-library/CJ83GDKYAF1kzf" target="_blank">Casing Pressure Tests OAC 1501:9-1-08 (D)(3)</a><br />
              }
              @if (segmentIndex === 0) {
                <a class="rules-link" href="/law-library/10PjAf16x7xV1MG8" target="_blank">Surface Water Infiltration OAC 1501:9-1-08 (F)</a><br />
              }
            }
            @default {
              None
            }
          }
        </div>
      }
      @switch (true) {
        @case (enableEditing && canBeCompleted && !isComplete) {
          <div class="grid-x">
            <div class="cell large-12 bold">
              Do you want to add another string?
            </div>
            <div class="cell large-12">
              <select [(ngModel)]="addNewString" (ngModelChange)="addNewStringChanged()">
                <option [ngValue]=""> </option>
                <option [ngValue]="'true'">Yes</option>
                <option [ngValue]="'false'">No</option>
              </select>
            </div>
          </div>
        }
        @case (enableEditing && !canBeCompleted) {
          <div class="grid-x">
            <div class="cell large-12 bold required">
              Your casing program requires an additional string to be considered lawful.  Click 'Next' to add another string.
            </div>
          </div>
        }
        @case (enableEditing && canBeCompleted && isComplete) {
          <div class="grid-x">
            <div class="cell large-12 bold">
              Your casing program is complete.  Click 'Next' to review the casing program.
            </div>
          </div>
        }
        @case (!enableEditing && segmentIndex !== currentCasingPlan.wellSegments.length - 1) {
          <div class="cell large-12 bold">
            Click 'Next' to review the next string.
          </div>
        }
        @case (!enableEditing && segmentIndex === currentCasingPlan.wellSegments.length - 1) {
          <div class="cell large-12 bold">
            Click 'Next' to review the full casing program.
          </div>
        }
      }
    }
  </div>
}
<confirm-dialog [showDialog]="dialogService.showDialog" [dialogType]="dialogService.dialogType" [message]="dialogService.message" (onDialogConfirm)="onDialogConfirm()" (onDialogClose)="onDialogClose()"></confirm-dialog>
